import { api } from "../config";

export const apiCallsPillars = {
    Actions: {
        GetDevices: async (filters) => {
            try {
                const fromDateTime = filters.fromDate.hour(filters.fromTime.hour()).minute(filters.fromTime.minute() || 0).second(filters.fromTime.second() || 0);
                const toDateTime = filters.toDate.hour(filters.toTime.hour()).minute(filters.toTime.minute() || 0).second(filters.toTime.second() || 0);
                const fromDateFormat = fromDateTime.toISOString();
                const toDateFormat = toDateTime.toISOString();
                const response = await api.get("Pillars", {
                    params: {
                        Active: filters.deviceStates.active, 
                        Dimmed: filters.deviceStates.dim, 
                        NotResponse: filters.deviceStates.error, 
                        Closed: filters.deviceStates.off, 
                        SuccessConnected: filters.deviceStates.selected, 
                        HasError: filters.deviceStates.deverror,
                        Gateways: filters.deviceStates.gateway,
                        Lights: filters.deviceStates.light,
                        DateFrom: fromDateFormat, 
                        DateTo: toDateFormat,
                        TimeFrom: filters.fromTime.hour(),
                        TimeTo: filters.toTime.hour()
                    }
                });
                return response.data;
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
                throw error;
            }
        },
        
        SendToSelected: async (name, dimlevel) => {
            try {
                const response = await api.post("Pillars/send-selected", {
                    name: name,
                    dimlevel: dimlevel,
                })

                return response;

            } catch (error) {
                console.error("API Error ", error);
                throw error
            }
        },

        SendToSelectedPolygon: async (dimlevel, selectedDevices) => {
            try {

                const response = await api.post("Pillars/send-polygon", {
                    dimlevel: dimlevel,
                    selectedDevices: selectedDevices,
                });
                return response;
            } catch (error) {
                console.error("API Error:", error);
            }
        },

        RevertToSelected: async (name) => {
            try {
                const response = await api.post("Pillars/revert-selected", {
                    name: name,
                })

                return response;
            } catch (error) {
                console.error("API Error ", error);
                throw error
            }
        },
        
        Port25 : async (deviceId) => {
            try {
                const response = await api.get(`Pillars/device-info/${deviceId}`);
                return response.data;
                
            } catch (error) {
                console.error("API Error ", error);
            }
        },

        GetSiteParameters: async (deviceId) => {
            try {
                const response = await api.get(`Pillars/site-info/${deviceId}`, {
                    id: deviceId
                });
                return response.data.data;
            } catch (error) {
                console.error("API Error: ", error);
            }
        },

        GetDevicesForExport: async (filters) => {
            try {
                const payload = {
                    data: "",
                    active: filters.deviceStates.active,
                    dim: filters.deviceStates.dim,
                    error: filters.deviceStates.error,
                    off: filters.deviceStates.off,
                    selected: filters.deviceStates.selected,
                    deverror: filters.deviceStates.deverror,
                    datebetweenfrom: new Date(filters.fromDate).toISOString(),
                    datebetweento: new Date(filters.toDate).toISOString(),
                    fromhour: filters.fromTime.hour(),
                    tohour: filters.toTime.hour(),
                };
        
                const response = await api.post(
                    "ProfileChk.aspx/GetDevicesForExport",
                    JSON.stringify(payload),
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                );
        
                return response.data.Result|| [];
        
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
                throw error;
            }
        },        


    }
}